import React, { useEffect, useState } from "react";
import { IoIosArrowDown, IoMdCloudUpload } from "react-icons/io";
import { useForm, Controller } from "react-hook-form";
import { MdDelete } from "react-icons/md";
import { FaFilePdf } from "react-icons/fa";
import toast from "react-hot-toast";
import { PatternFormat } from "react-number-format";
import ContactCollapse from "./CollapseMenu";
import { RootState } from "../../store/root-reducer";
import { isScopeLoading } from "../../store/scope-loading/helpers";
import { UserScope } from "../../store/user/types";
import { connect, useDispatch } from "react-redux";
import Button from "../../components/Button";
import { submitTicket } from "../../store/user/actions";
import { SUPPORT_REQUEST_OPTIONS } from "../../constant";

function SubmitTicket({ isloading, email }) {
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    control,
    formState: { isValid },
    trigger,
    reset,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      Email: email,
      phone: "",
      help: "",
      message: "",
      fileUpload: "",
    },
  });

  useEffect(() => {
    trigger("fileUpload");
  }, [trigger]);

  const onSubmit = (data: any) => {
    dispatch(
      submitTicket(
        {
          data,
          files: selectedFiles,
        },
        () => {
          toast.success("Your ticket has been submitted");
          reset({
            Email: "",
            phone: "",
            help: "",
            message: "",
            fileUpload: "",
          });
          setSelectedFiles([]);
        }
      )
    );
  };

  function shortenFileName(filename: string) {
    const maxLength = 20;
    const extIndex = filename.lastIndexOf(".");
    const extension = filename.slice(extIndex);
    const nameWithoutExt = filename.slice(0, extIndex);

    const nameParts = nameWithoutExt.split("-");
    const nameLength = nameWithoutExt.length;

    if (nameLength > maxLength) {
      return `${nameWithoutExt.slice(0, 6)}....${nameParts
        .slice(-2)
        .join("-")}${extension}`;
    }
    return filename;
  }

  return (
    <div>
      <div className="my-10 container text-center">
        <h2 className="sm:text-4xl text-3xl font-bold mb-4">Contact Support</h2>
        <p className="text-[#4F4F4F]">
          Have any questions? We'd love to hear from you.
        </p>
      </div>
      <div className="container">
        <div className="grid grid-cols-12 lg:gap-6 gap-4 mb-10">
          <div className="lg:col-span-5 md:col-span-6 col-span-12 bg-white py-4 px-6 rounded-lg border border-gray-200 h-fit mb-5">
            <div className="space-y-2 mb-5">
              <h3 className="text-3xl font-semibold">Get in touch</h3>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-3">
                <p className="mb-1">
                  Email
                  <span className="text-[#FF1414]">*</span>
                </p>
                <Controller
                  control={control}
                  name="Email"
                  rules={{
                    required: "Email is required",
                    pattern: {
                      value: /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "Please enter a valid email",
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <input
                        type="email"
                        className={`border w-full p-2 rounded-md focus:outline-none ${
                          error
                            ? "border-red-500 focus:border-red-500"
                            : "border-gray-200"
                        }`}
                        placeholder="user@email.com"
                        {...field}
                      />
                      {error && (
                        <p className="mt-1 text-red-500 text-xs">
                          {error.message}
                        </p>
                      )}
                    </>
                  )}
                />
              </div>
              <div className="mb-3">
                <p className="mb-1">Phone number</p>
                <Controller
                  control={control}
                  name="phone"
                  rules={{
                    pattern: {
                      value:
                        /^(\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4}))?$/,
                      message: "Please enter a valid phone number",
                    },
                  }}
                  render={({ field: { value, onChange } }) => (
                    <>
                      <PatternFormat
                        className="border border-gray-200 w-full p-2 rounded-md"
                        placeholder="(987) 654 3210"
                        format="(###) ### ####"
                        mask="_"
                        value={value}
                        onValueChange={(values) => {
                          onChange(values.value);
                        }}
                      />
                    </>
                  )}
                />
              </div>
              <div className="mb-3">
                <p className="mb-1">
                  Support Request Reason
                  <span className="text-[#FF1414]">*</span>
                </p>
                <Controller
                  control={control}
                  name="help"
                  rules={{
                    required: "Please Select a Option",
                  }}
                  render={({ field }) => (
                    <div className="relative">
                      <select
                        className="border border-gray-200 w-full p-2 rounded-md appearance-none"
                        {...field}
                      >
                        <option value="">Select...</option>
                        {SUPPORT_REQUEST_OPTIONS.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                      <IoIosArrowDown
                        className="absolute right-2  top-1/2  -translate-y-1/2"
                        size={24}
                        color="#57637D"
                      />
                    </div>
                  )}
                />
              </div>
              <div className="mb-3 flex flex-col">
                <p className="mb-1">
                  Message
                  <span className="text-[#FF1414]">*</span>
                </p>
                <Controller
                  control={control}
                  name="message"
                  rules={{
                    validate: (value = "") => {
                      value ||= "";
                      return value.toString().trim().length === 0
                        ? "Message is required"
                        : true;
                    },
                  }}
                  render={({ field }) => (
                    <textarea
                      className="border border-gray-200 w-full p-2 rounded-md resize-none"
                      placeholder={"Write here..."}
                      {...field}
                    />
                  )}
                />
              </div>
              <div>
                <p className="mb-1">Files(s) upload</p>
                <label
                  className=" bg-gray-100 rounded-md border border-gray-300 p-2 flex justify-center items-center w-fit cursor-pointer"
                  htmlFor="fileUpload"
                >
                  <IoMdCloudUpload className="text-lg mr-1" />
                  Upload files
                </label>
                <input
                  className="border border-gray-200 w-full p-2 rounded-md hidden"
                  id="fileUpload"
                  multiple
                  type="file"
                  accept=".jpg,.png,.pdf,.jpeg"
                  {...register("fileUpload", {
                    onChange: (e) => {
                      const files: File[] = Array.from(e?.target?.files || []);
                      const validFiles = files.filter(
                        (file) => file.size <= 20 * 1024 * 1024
                      );
                      const invalidFiles = files.filter(
                        (file) => file.size > 20 * 1024 * 1024
                      );
                      if (invalidFiles.length > 0) {
                        toast.error(
                          `File ${files.map((i) => {
                            return i.name;
                          })} is too big. Should be less then 20 MB`,
                          {
                            position: "bottom-center",
                          }
                        );
                      }
                      setSelectedFiles((old) => [...old, ...validFiles]);
                    },
                  })}
                />
              </div>
              <p className="text-gray-500 text-sm font-normal">
                Accepted File Types: JPG, PNG, PDF; 20 MB Maximum File Size per
                file.
              </p>
              <div className="mb-3 max-h-48 overflow-auto p-3">
                {selectedFiles.map((preview, index) => {
                  return (
                    <div key={index} className="flex items-center w-full">
                      <div className="flex items-center mb-2 bg-gray-100 rounded-md p-2 w-full">
                        {preview?.type?.startsWith("image/") ? (
                          <>
                            <img
                              src={URL.createObjectURL(preview)}
                              alt={`Preview ${index + 1}`}
                              className="size-12 object-cover rounded-[36px] mr-2"
                            />
                            <span>{shortenFileName(preview.name)}</span>
                          </>
                        ) : preview?.type?.startsWith("application/pdf") ? (
                          <>
                            <FaFilePdf className="size-12 object-cover mr-2" />
                            <span>{shortenFileName(preview.name)}</span>
                          </>
                        ) : null}
                      </div>
                      <button
                        type="button"
                        className="ml-2"
                        onClick={() =>
                          setSelectedFiles((prevPreviews) =>
                            prevPreviews?.filter((_, i) => i !== index)
                          )
                        }
                      >
                        <MdDelete
                          size={24}
                          className="text-gray-500 hover:text-gray-800"
                        />
                      </button>
                    </div>
                  );
                })}
              </div>
              <Button
                disabled={!isValid}
                isLoading={isloading}
                btnClassName="w-full"
              >
                Submit
              </Button>
            </form>
          </div>
          <div className="lg:col-span-7 md:col-span-6 col-span-12 space-y-5 ">
            <ContactCollapse />
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  isloading: isScopeLoading(state.scopeLoading, `contact-${UserScope}`),
  email: state.user.email,
});

export default connect(mapStateToProps)(SubmitTicket);
